var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"p-4 m-4 text-center"},[_vm._v("Please select a company")])
}
var staticRenderFns = []

export { render, staticRenderFns }